import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import Fa from 'react-fontawesome';
import { each, reduce, capitalize } from 'lodash';
import ProgressBar from '../../../../components/progress-bar';
import { getColorFromKey } from '../../../../util/helpers';
import DatetimeDisplay from '../../../../components/date-time-display';
import NumberDisplay from '../../../../components/number-display';
import MoneyDisplay from '../../../../components/money-display';

import {
  getOpportunities,
  getOpportunityLoading,
  getOpportunityLoaded,
  getWinLossTrackingsLoading,
  getWinLossTrackingsLoaded,
  getUnlinkedContacts,
  getUnlinkedContactLoading,
  getUnlinkedContactLoaded,
} from '../../WinLossReducer';

import styles from './styles.css';

class WinLossStats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      unsubmitted: {},
      submitted: {},
      minDate: null,
      linkedInterviews: {},
    };
  }

  componentDidMount() {
    this.calculate();
  }

  componentDidUpdate(prevProps) {
    if ((this.props.loaded && !prevProps.loaded) || (this.props.submitStatus !== prevProps.submitStatus && this.props.submitStatus === 'success')) {
      this.calculate();
    }
  }

  calculate() {
    const { opportunities } = this.props;
    const unsubmitted = {
      Won: { count: 0, amount: 0, opportunityIds: [] },
      Lost: { count: 0, amount: 0, opportunityIds: [] },
      'No Decision': { count: 0, amount: 0, opportunityIds: [] },
      total: { count: 0, amount: 0, opportunityIds: [] },
    };
    const submitted = {
      Won: { count: 0, amount: 0, opportunityIds: [] },
      Lost: { count: 0, amount: 0, opportunityIds: [] },
      'No Decision': { count: 0, amount: 0, opportunityIds: [] },
      total: { count: 0, amount: 0, opportunityIds: [] },
    };
    const linkedInterviews = {
      count: 0,
      amount: 0,
      opportunityIds: [],
    };
    let minDate = null;
    each(opportunities, (opportunity) => {
      const { stage, amount } = opportunity;
      const opportunityId = opportunity.opportunity_id;
      const isSubmitted = opportunity.tracking && opportunity.tracking.submitted;
      const closeDate = opportunity.close_date ? moment(opportunity.close_date) : null;
      if (!minDate) {
        minDate = closeDate;
      } else {
        minDate = moment.min(closeDate, minDate);
      }
      if (opportunity.tracking && opportunity.tracking.contacts) {
        each(opportunity.tracking.contacts, (contact) => {
          if (contact.approved) {
            linkedInterviews.count += 1;
            linkedInterviews.amount += amount;
            linkedInterviews.opportunityIds.push(opportunityId); // duplicate
          }
        });
      }
      if (isSubmitted && submitted[stage]) {
        submitted[stage].count += 1;
        submitted[stage].amount += amount || 0;
        submitted[stage].opportunityIds.push(opportunityId);
        submitted.total.count += 1;
        submitted.total.amount += amount || 0;
      } else if (!isSubmitted && unsubmitted[stage]) {
        unsubmitted[stage].count += 1;
        unsubmitted[stage].amount += amount || 0;
        unsubmitted[stage].opportunityIds.push(opportunityId);
        unsubmitted.total.count += 1;
        unsubmitted.total.amount += amount || 0;
      }
    });
    this.setState({ unsubmitted, submitted, minDate, linkedInterviews });
  }

  renderStats(title, stats) {
    const { minDate } = this.state;
    const rows = reduce(stats, (items, num, statType) => {
      const color = getColorFromKey(statType);
      const style = { color };
      if (statType === 'total') {
        style.fontWeight = 'bold';
      }
      items.push((
        <tr key={statType} style={style}>
          <td>{capitalize(statType)}</td>
          <td className="text-right"><NumberDisplay value={num.count} precision={0} /></td>
          <td className="text-right"><MoneyDisplay value={num.amount} abbreviated /></td>
        </tr>
      ));
      return items;
    }, []);
    const dateComp = minDate ? <span>Since <DatetimeDisplay value={minDate} format="long" /></span> : null;
    return (
      <div className={`panel panel-default ${styles.panel}`}>
        <div className="panel-heading">
          {title} {dateComp}
        </div>
        <div className="panel-body">
          <table className="table table-condensed">
            <tbody>
              {rows}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  render() {
    const {
      loaded,
      unlinkedLoading,
      totalUnlinked,
    } = this.props;
    const { unsubmitted, submitted, linkedInterviews } = this.state;
    if (!loaded) {
      return (
        <div>
          <ProgressBar />
          <p />
        </div>
      );
    }

    const total = linkedInterviews.count + totalUnlinked;
    return (
      <div className="row">
        <div className="col-sm-4">
          {this.renderStats('Unsubmitted', unsubmitted)}
        </div>
        <div className="col-sm-4">
          {this.renderStats('Submitted', submitted)}
        </div>
        <div className="col-sm-4">
          <div className={`panel panel-default ${styles.panel}`}>
            <div className="panel-heading">
              Captured Feedback
            </div>
            <div className="panel-body">
              <table className="table table-condensed">
                <tbody>
                  <tr>
                    <td>Linked interviews</td>
                    <td className="text-right"><NumberDisplay value={linkedInterviews.count} precision={0} /></td>
                  </tr>
                  <tr>
                    <td>Unlinked interviews</td>
                    <td className="text-right">
                      {unlinkedLoading && (<Fa name="spinner" spin />)}
                      {!unlinkedLoading && (<NumberDisplay value={totalUnlinked} precision={0} />)}
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Total interviews</strong></td>
                    <td className="text-right">
                      <strong>
                        {unlinkedLoading && (<Fa name="spinner" spin />)}
                        {!unlinkedLoading && (<NumberDisplay value={total} precision={0} />)}
                      </strong>
                    </td>
                  </tr>
                  <tr><td>&nbsp;</td><td>&nbsp;</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    opportunities: getOpportunities(state),
    loaded: !getWinLossTrackingsLoading(state) && getWinLossTrackingsLoaded(state) &&
      !getOpportunityLoading(state) && getOpportunityLoaded(state),
    unlinkedLoading: getUnlinkedContactLoading(state) || !getUnlinkedContactLoaded(state),
    totalUnlinked: getUnlinkedContacts(state).length,
  };
}
WinLossStats.propTypes = {
  opportunities: PropTypes.arrayOf(PropTypes.shape({})),
  loaded: PropTypes.bool,
  submitStatus: PropTypes.string,
  totalUnlinked: PropTypes.number,
  unlinkedLoading: PropTypes.bool,
};
WinLossStats.defaultProps = {
  opportunities: [],
  loaded: false,
  submitStatus: null,
  unlinkedLoading: true,
  totalUnlinked: 0,
};

export default connect(mapStateToProps)(WinLossStats);
